module.exports = require('./lib/marvel-ui-select.js');



//////////////////
// WEBPACK FOOTER
// ./~/@marvelapp/marvel-ui/select.js
// module id = 456
// module chunks = 168707334958949